import ApplicationController from '../../javascript/controllers/application_controller'

// Marketing::AnalyticsOptOut — toggles Plausible's localStorage opt-out flag.
// The bundled @plausible-analytics/tracker sends no events while
// localStorage.plausible_ignore === "true". The flag is per browser + device.
// A custom controller (not @stimulus-components/reveal) because it also
// reads/writes localStorage, which reveal can't do.
const FLAG = 'plausible_ignore'

export default class extends ApplicationController {
  static targets = ['active', 'ignored']

  connect() {
    this.render()
  }

  optOut() {
    this.setFlag(true)
    this.render()
  }

  optIn() {
    this.setFlag(false)
    this.render()
  }

  render() {
    const ignored = this.ignored
    if (this.hasActiveTarget) this.activeTarget.hidden = ignored
    if (this.hasIgnoredTarget) this.ignoredTarget.hidden = !ignored
  }

  // localStorage throws in Safari private mode / sandboxed iframes — fail open
  // (treat as "measurement active") rather than breaking the widget.
  get ignored() {
    try {
      return localStorage.getItem(FLAG) === 'true'
    } catch {
      return false
    }
  }

  setFlag(value) {
    try {
      if (value) {
        localStorage.setItem(FLAG, 'true')
      } else {
        localStorage.removeItem(FLAG)
      }
    } catch {
      // Can't persist (private mode) — the in-memory toggle still updates.
    }
  }
}
